<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/KPI/Index' }">绩效设置</el-breadcrumb-item>
                        <el-breadcrumb-item>KPI结果</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row :gutter="2">
                <el-col :span="5">
                    <el-input size="small" clearable v-model="searchName" placeholder="请输入员工姓名"></el-input>
                </el-col>
                <el-col :span="1">
                    <el-button icon="el-icon-search" size="small" @click="SearchByName"></el-button>
                </el-col>
            </el-row>
            <el-row v-loading="loading" >
                <!-- 头部信息 -->
                <div style="margin-bottom:50px;" v-for="item in AllKPIInfo" :key="item.sysUser.Id" > 
                    <div style="margin-top:20px;background-color: #f0f2f2;padding-top: 10px;padding-bottom: 15px;" class="viewKPITitle">
                        <el-row style="margin-top:10px;text-align:center;">{{item.sysUser.MainDeptsName}} KPI考核表</el-row>
                        <el-row style="margin-top:10px;">
                            <el-col :span="6">
                                被考核者姓名：<span v-if="AllKPIInfo.length>0">{{item.sysUser.TrueName}}</span>
                            </el-col>
                            <el-col :span="6">
                                被考核者岗位：<span v-if="AllKPIInfo.length>0">{{item.sysUser.Duty}}</span>
                            </el-col>
                            <el-col :span="6">
                                被考核者工号：<span v-if="AllKPIInfo.length>0">{{item.sysUser.UserCode}}</span>
                            </el-col>
                            <el-col :span="6">
                                考核周期：<span v-if="AllKPIInfo.length>0">{{item.userKPI[0].Period}}{{item.userKPI[0].PeriodType==0?'月':'季度'}}</span>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top:10px;">
                            <el-col :span="6">
                                考核者姓名：<span v-if="AllKPIInfo.length>0">{{item.userKPI[0].LeadTrueName}}</span>
                            </el-col>
                            <el-col :span="6">
                                <!-- {{viewKPITitle.Period}}{{viewKPITitle.PeriodType==1?'季度':'月'}}-->
                                考核者岗位：<span v-if="AllKPIInfo.length>0">{{item.userKPI[0].LeadDuty}}</span>
                            </el-col>
                        </el-row>
                    </div>
                    <!-- 考核列表信息  show-summary :summary-method="getSummaries"-->
                    <el-table border :data="item.userKPI" style="width: 100%;margin-top:20px;" v-loading="loading" size="small">
                        <el-table-column prop="KPI" width="200" label="KPI名称"></el-table-column>
                        <el-table-column prop="Explain" width="280" label="指标说明"></el-table-column>
                        <el-table-column prop="Contents" width="320" label="考核细则"></el-table-column>
                        <el-table-column label="KPI类型">
                            <template slot-scope="scope">
                                {{scope.row.KPIType == 0 ? "职能" : (scope.row.KPIType == 1 ? "业绩" : (scope.row.KPIType == 2 ? "自定义" : (scope.row.KPIType == 3 ? "其它" : (scope.row.KPIType == 4 ? "内部管理指标" : (scope.row.KPIType == 5 ? "客户指标" : (scope.row.KPIType == 6 ? "敬业度" : (scope.row.KPIType == 7 ? "重点项目" : "团队管理")))))))}}
                            </template>
                        </el-table-column>
                        <el-table-column label="周期">
                            <template slot-scope="scope">{{ scope.row.PeriodType==0?'月度':'季度' }}</template>
                        </el-table-column>
                        <el-table-column prop="KPIWeight" label="KPI权重"></el-table-column>
                        <el-table-column prop="Execution" label="完成情况"></el-table-column>
                        <el-table-column prop="SelfScore" label="自评评分">
                            <template slot-scope="scope">
                                {{scope.row.Status == 0 ?'':scope.row.SelfScore}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="LeadScore" label="直属领导评分">
                            <template slot-scope="scope">
                                {{scope.row.LeadStatus == 0 ?'':scope.row.LeadScore}}
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- <div style="height:20px;background-color:#f0f2f2;margin-top: 20px;"></div> -->
                </div>
            </el-row>
            <el-row style="text-align:right;">
                <el-col >
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="pageSizes"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    style="float:right"
                    ></el-pagination>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<script >
import { getUrlKey  } from "../../until/ZeusApiSDK/Logic/ImageStr";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { GetUserByItemId } from "../../until/ZeusApiSDK/Logic/KPILogic";
export default {
    data() {
        return {
            loading:true,
            AllKPIInfo:[],
            KPIItems:[],
            userinfo:{},//登录信息
            userCode:'',//当前登录信息
            searchName:'',//搜索条件
            itemId:'',//KPI id
            pageSizes: [10, 20, 50, 100, 200],
            pageSize: 10,
            pageIndex: 1,
            totalCount: 0,
        }
    },
    created() {
        //当前用户id
        this.itemId=getUrlKey('id');
        if(!this.itemId){
            this.$router.push("/KPI/KPISetting");
        }
        //获取当前登录用户信息
        this.GetUserinfo();
        //获取KPI结果
        this.GetKPIResult();
    },
    methods:{
        //获取当前登录用户信息
        GetUserinfo:function(){
            this.userinfo=GetCurrentUserInfo();
            this.userCode=this.userinfo.UserCode;
        },
        //获取KPI结果
        GetKPIResult:async function(){
            await GetUserByItemId(this.itemId,this.pageIndex,this.pageSize,this.searchName).then(res=>{
                this.AllKPIInfo=res.Data.DataList;
                this.totalCount=res.Data.totalCount;
                this.loading=false;
            });
        },
        //搜索条件
        SearchByName:function(){
            //获取KPI结果
            this.GetKPIResult();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.GetKPIResult();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.GetKPIResult();
        },
    }
}
</script>
<style scoped lang="less">
.viewKPITitle {
  text-align: left;
  font-size: 14px;
  color: #72767b;
}
</style>